<template>
    <v-layout row wrap justify-space-between class="BigFooter pa-2">
      <v-flex xs12 sm6 class="text-xs-left">
        <SocialMediaLinks :public_settings="siteLinks"></SocialMediaLinks>
      </v-flex>

      <v-flex xs12 sm6 class="text-xs-right" >
        Policies: <a href="/m/policies/tos">Terms</a> |
        <a href="/m/policies/privacy">Privacy</a> |
        <a href="/m/policies/cookie">Cookie</a>
        &copy; {{ new Date().getFullYear() }}
      </v-flex>
    </v-layout>
</template>

<script>

import SocialMediaLinks from '../common/SocialMediaLinks'

export default {
  components: {
    SocialMediaLinks
  },
  data () {
    return {
      siteLinks: {
        facebookLink: 'smartkidsmarket',
        twitterLink: 'smartkidsmarket',
        // youtubeLink: 'channel/UCK9OeYlvNW1jEUWJJY2eTfw'
      }
    }
  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

.BigFooter {
  background-color: lightgray;
}
</style>
